import type FontPickerStore from './schema/FontPickerStore';
import { FONT_NAME_MENU_ITEMS, FONT_SIZE_MENU_ITEMS } from 'owa-format-options';
import { createStore } from 'satcheljs';

const fontPickerStoreData: FontPickerStore = {
    fontName: {
        displayValue: null,
        mru: [],
        items: [...FONT_NAME_MENU_ITEMS],
    },
    fontSize: {
        displayValue: null,
        mru: [],
        items: [...FONT_SIZE_MENU_ITEMS],
    },
    isLocalFontListLoaded: false,
};

export const getStore = createStore<FontPickerStore>('fontPicker', fontPickerStoreData);

export const store = getStore();
